import React, { useEffect, useState } from "react";
import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { useLocation } from "react-router-dom";
import { MdFilterList } from "react-icons/md";

const GamesCategoryFilters = ({ allProviders, selectedProviderFilter, setSelectedProviderFilter, searchGames, setSearchGames }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [searchProviders, setSearchProviders] = useState("");

  const filteredProviders =
    searchProviders === ""
      ? allProviders
      : allProviders?.filter((p) => {
          return p.provider_name.toLowerCase().includes(searchProviders.toLowerCase());
        });

  useEffect(() => {
    setSelectedProviderFilter([]);
  }, [location]);

  return (
    <div className="grid md:grid-cols-3 grid-cols-1 justify-center items-center gap-3 md:space-y-0 space-y-3 my-6">
      {location.pathname !== "/livecasino" ? (
        <div className="flex gap-3 items-center overflow-x-auto">
          <label className="text-white text-xs text-nowrap">{t("ORDER BY")}:</label>
          <div className="[&_button]:border [&_button]:border-primary [&_button]:px-4 [&_button]:py-1 [&_button]:text-primary [&_button]:text-nowrap [&_button]:font-semibold [&_button]:text-sm [&_button:focus]:bg-primary [&_button:focus]:text-black flex gap-3">
            <button type="button" className="rounded-full">
              Popularité
            </button>
            <button type="button" className="rounded-full">
              Plus récent
            </button>
            <button type="button" className="rounded-full">
              Ordre Alphabétique
            </button>
          </div>
        </div>
      ) : (
        <div></div>
      )}
      {/* PROVIDERS FILTER */}
      {/* {location.pathname !== "/providers" && location.pathname !== "/pragmatic" ? ( */}
      {window.location.pathname !== "/casino/pragmatic" ? (
        <div className="gap-4 flex items-center justify-center ">
          <label className="text-white text-xs">PROVIDERS:</label>
          <Combobox
            as="div"
            className="max-w-[450px] w-full relative"
            value={selectedProviderFilter}
            onChange={(value) => setSelectedProviderFilter(value || "")}
            onClose={() => setSearchProviders("")}
          >
            <div className="relative">
              <ComboboxInput
                placeholder="All Game Providers"
                displayValue={(val) => val?.provider_name}
                className={clsx(
                  "w-full flex text-nowrap rounded bg-[#646262] border-0 py-2 pr-10 pl-3 text-[16px] font-semibold text-white",
                  "focus:outline-none data-[focus]:outline-0 data-[focus]:-outline-offset-2 data-[focus]:outline-white/25  placeholder:text-white/50"
                )}
                onChange={(event) => setSearchProviders(event.target.value)}
              />
              <ComboboxButton className="group absolute left-0 inset-y-0 px-2.5 w-full">
                {/* {selectedProviderFilter?.provider_name} */}
                <MdFilterList className="group pointer-events-none absolute top-2 right-2.5 size-5 fill-primary-dark" aria-hidden="true" />
              </ComboboxButton>
            </div>

            <ComboboxOptions
              // anchor="bottom"
              transition
              className={clsx(
                "w-[var(--input-width)] absolute top-[100%] max-h-[400px] rounded bg-white border-b border-black/15 p-1 [--anchor-gap:var(--spacing-1)] empty:invisible overflow-y-auto z-10",
                "transition duration-100 ease-in data-[leave]:data-[closed]:opacity-0"
              )}
            >
              {filteredProviders?.map((item) => {
                return (
                  <ComboboxOption
                    key={item._id}
                    value={item}
                    className="text-primary group flex cursor-pointer items-center gap-2 px-4 py-[6px] select-none hover:text-primary border-b boder-b-[#62616b] "
                  >
                    {item.provider_name}
                  </ComboboxOption>
                );
              })}
            </ComboboxOptions>
          </Combobox>
          {/* <Listbox
          as="div"
          className="max-w-[450px] w-full"
          value={selectedProviderFilter}
          onChange={setSelectedProviderFilter}
          // defaultValue={allProviders[0].provider_name}
        >
          <ListboxButton
            className={clsx(
              "w-full relative flex text-nowrap rounded-lg bg-[#575c75] border-0 py-2 pr-10 pl-3 text-left text-sm/6 text-white",
              "focus:outline-none data-[focus]:outline-0 data-[focus]:-outline-offset-2 data-[focus]:outline-white/25"
            )}
          >
            {selectedProviderFilter ? selectedProviderFilter.provider_name : "All"}
            <MdFilterList className="group pointer-events-none absolute top-2 right-2.5 size-5 fill-primary-dark" aria-hidden="true" />
          </ListboxButton>
          <ListboxOptions
            anchor="bottom-end"
            transition
            className={clsx(
              "w-[var(--button-width)] mt-2 rounded-lg border-2 border-white bg-white px-5 focus:outline-none h-[300px] overflow-y-auto",
              "transition duration-100 ease-in scroll-smooth no-scrollbar w-full"
            )}
          >
           
            {allProviders?.map((item) => (
              <ListboxOption
                key={item._id}
                value={item}
                className="text-white text-sm group flex cursor-pointer items-center gap-2 py-2 select-none hover:text-primary border-b boder-b-[#62616b] "
              >
                {item.provider_name}
              </ListboxOption>
            ))}
          </ListboxOptions>
        </Listbox> */}
        </div>
      ) : (
        <div></div>
      )}

      <div className="flex md:justify-end justify-center">
        <div className="relative w-80">
          <input
            value={searchGames}
            placeholder="Search"
            onChange={(e) => setSearchGames(e.target.value)}
            className="cursor-pointer w-full text-left bg-[#4a4a4a] text-white pl-10 pr-3 py-2 rounded shadow focus:outline-none focus:ring-1 focus:ring-primary "
          />
          <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="#da0e0e" className="w-4 h-4">
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </span>
        </div>
      </div>
      {/* ) : null} */}
    </div>
  );
};

export default GamesCategoryFilters;
